import React, { Component } from 'react';
import Formulario from './FaseForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class Fase extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leer, getModulo, listarCentroTrabajo } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4])
        listarCentroTrabajo();
    }
    
    render(){
        const { registroFase, modificarFase, loader, modulo, listaCentros, lectura } = this.props;
        const { crear } = this.state;
        const funcionEnvio = crear ? registroFase : modificarFase;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    onSubmit = {funcionEnvio}
                    crear = {crear}
                    modulo = {modulo}
                    listaCentros = {listaCentros}
                    lectura = {lectura}
                />
            </LoadMask>
        );
    }
}

export default Fase;
